export const getUserInitials = (firstName?: string, lastName?: string) => {
  // In some cases, there may not be a 2nd name. Doing the same check for 1st name just in case.
  const fName = firstName?.trim()[0] || '';
  const lName = lastName?.trim()[0] || '';

  return (fName + lName).toUpperCase();
};
